/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import PacmanLoader from 'react-spinners/PacmanLoader';
import { Box } from '@mui/system';

export interface Props {
	size?: number;
	color?: string;
	loading?: boolean;
}

function MainLoadingIndicator(props: Props): JSX.Element {
	const theme: Theme = useTheme();
	const { loading } = props;
	let { size, color } = props;
	size = size ? size : 20; // default 20
	color = color ? color : theme.palette.primary.main; // default color
	return (
		<Box
			sx={{
				margin: 0,
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}}
		>
			<PacmanLoader size={size} color={color} loading={loading} />
		</Box>
	);
}
export default MainLoadingIndicator;
